import { ProductType } from '../constants/productTypes';
import { ProductBuilderMachineContext } from '../types';
import { getBaseProduct } from './getBaseProduct';

type GetProductType = (
  context: ProductBuilderMachineContext,
) => ProductType | null;

export const getProductType: GetProductType = context => {
  const baseProduct = getBaseProduct(context);

  let baseProductType = baseProduct
    ? baseProduct.type
    : context.products[0].type;

  if (
    window.location.pathname.includes('roller-day-night') &&
    baseProduct &&
    baseProduct.type === 'Roller Blind Single Chain'
  ) {
    baseProductType = 'Roller Blind Day/Night Chain';
  }
  if (
    window.location.pathname.includes('roller-day-night') &&
    baseProduct &&
    baseProduct.type === 'Roller Blind Single Chainless'
  ) {
    baseProductType = 'Roller Blind Day/Night Chainless';
  }

  return baseProduct ? baseProductType : null;
};
